<!--
  --
  -- ナビゲーションリンクリスト コンポーネント
  --
  -->
<template>
  <nav class="c-header-nav">
    <c-item
      v-for="(link, index) in links"
      :key="index"
      :link="link"
    />
  </nav>
</template>

<script>
import CItem from './CItem.vue'

export default {
  name: 'CNav',
  components: {
    CItem
  },
  props: {
    links: {
      type: Array,
      required: true
    }
  }
}
</script>
